import { useNavigate } from "react-router-dom"

export function DashboardResign() {
  const navigate = useNavigate()

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-[#bceda6] font-robo'>
      <div className='w-full max-sm:scale-90 flex flex-col items-center'>
      <p className='font-bold text-3xl text-center mt-4'>Re-Sign Document</p>
        <div className='flex flex-col items-center gap-4 mt-10'>
          <p>We need to re sign your documents to continue your application. Please click the button below to get started.</p>
          <button className='cursor-pointer flex justify-center bg-blue-500 px-4 py-2 rounded-md text-white' onClick={() => navigate('/resign')}>
            Resign
          </button>
        </div>
      </div>
    </div>
  )
}